export enum KycMethodsEnumeration {
  ACCOUNT_CHECK = 'ACCOUNT_CHECK',
  BIZUM = 'BIZUM',
  VIDEOCALL = 'VIDEOCALL',
}
